export const GET_LESSONS = 'GET_LESSONS';
export const GET_LESSONS_FAILED = 'GET_LESSONS_FAILED';
export const GET_LESSONS_SUCCESS = 'GET_LESSONS_SUCCESS';
export const GET_LESSON_TYPES = 'GET_LESSON_TYPES';
export const GET_LESSON_TYPES_SUCCESS = 'GET_LESSON_TYPES_SUCCESS';
export const GET_LESSON_TYPES_FAILED = 'GET_LESSON_TYPES_FAILED';
export const SAVE_LESSON_IMAGE = 'SAVE_LESSON_IMAGE';
export const SAVE_LESSON_IMAGE_SUCCESS = 'SAVE_LESSON_IMAGE_SUCCESS';
export const SAVE_LESSON_IMAGE_FAILED = 'SAVE_LESSON_IMAGE_FAILED';
